import appConstants from '../../../../../../../appConstants';
import { mergeUserConfig } from '@dataGrid/gridUtilities';
import {
  MultiSelectFilter,
  StaticFilter
} from '@dataGrid/components/columnFilters';
import { formatAddress } from '../../../../../Dispatch/utils/utils';

export default class GridConfig {
  config: any;

  constructor(configuration: any) {
    this.config = GridConfig.getConfiguration(configuration);
  }

  static getConfiguration({userConfig}: any) {
    const defaultConfig = GridConfig.getDefaultConfiguration();
    return mergeUserConfig({
      defaultConfig,
      userConfig
    });
  }

  static DamagedRenderer = ({ data }: { data: any }) => {
    const { damagedPieces, pieces } = data;
    return `${damagedPieces}/${pieces} pcs`;
  };

  static ShortageRenderer = ({ data }: { data: any }) => {
    const { shortagePieces, pieces } = data;
    return `${shortagePieces}/${pieces} pcs`;
  };

  static outOfSequenceValueGetter = ({ data }: { data: any }) => {
    const { isOutOfSequence } = data;
    return isOutOfSequence ? 'Yes' : 'No';
  };

  static unableToAuditValueGetter = ({ data }: { data: any }) => {
    const { unableToAudit } = data;
    return unableToAudit ? 'Yes' : 'No';
  };

  static getBooleanFilterOptions = () => {
    return [
      { value: 'Yes', text: 'Yes' },
      { value: 'No', text: 'No' }
    ];
  };

  static CommentsValueGetter = ({ data }: { data: any }) => {
    return data.comments || null;
  };

  static CommentsTooltipValueGetter = ({ data }: { data: any }) => {
    const { comments } = data;
    return comments || null;
  };

  static getCustomerAddress = ({ data }: { data: any }) => {
    return formatAddress({
      address: data.consigneeAddress,
      address2: data.consigneeAddress2,
      zip: data.zip
    } as any);
  };

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.routeAuditShipments,
      keyColumn: 'proId',
      columns: [
        {
          headerName: 'Pro#',
          field: 'proId',
          headerTooltip: 'Pro Number',
          minWidth: appConstants.columnWidth.W_150,
          filter: MultiSelectFilter
        },
        {
          headerName: 'Damaged',
          field: 'damagedPieces',
          headerTooltip: 'Damaged Pieces',
          cellRenderer: GridConfig.DamagedRenderer,
          minWidth: appConstants.columnWidth.W_100,
          filter: MultiSelectFilter
        },
        {
          headerName: 'Shortage',
          field: 'shortagePieces',
          headerTooltip: 'Shortage Pieces',
          cellRenderer: GridConfig.ShortageRenderer,
          minWidth: appConstants.columnWidth.W_100,
          filter: MultiSelectFilter
        },
        {
          headerName: 'Out of Sequence',
          headerTooltip: 'Out of Sequence',
          valueGetter: GridConfig.outOfSequenceValueGetter,
          minWidth: appConstants.columnWidth.W_120,
          filter: StaticFilter,
          filterParams: {
            getStaticOptions: GridConfig.getBooleanFilterOptions
          }
        },
        {
          headerName: 'Unable To Audit',
          headerTooltip: 'Unable To Audit',
          valueGetter: GridConfig.unableToAuditValueGetter,
          minWidth: appConstants.columnWidth.W_120,
          filter: StaticFilter,
          filterParams: {
            getStaticOptions: GridConfig.getBooleanFilterOptions
          }
        },
        {
          headerName: 'Customer',
          field: 'consigneeName',
          headerTooltip: 'Customer Name',
          minWidth: appConstants.columnWidth.CUSTOMER_NAME,
          filter: MultiSelectFilter,
          tooltipField: 'consigneeName',
          filterParams:{
            width: appConstants.columnWidth.W_300
          }
        },
        {
          headerName: 'Address',
          field: 'consigneeAddress',
          headerTooltip: 'Customer Address',
          valueGetter: GridConfig.getCustomerAddress,
          minWidth: appConstants.columnWidth.CUSTOMER_ADDRESS,
          filter: MultiSelectFilter,
          tooltipValueGetter: (params: any) => params.value,
          filterParams:{
            width: appConstants.columnWidth.W_300
          }
        },
        {
          headerName: 'Comments',
          field: 'comments',
          headerTooltip: 'Comments',
          minWidth: appConstants.columnWidth.W_300,
          valueGetter: GridConfig.CommentsValueGetter,
          tooltipValueGetter: GridConfig.CommentsTooltipValueGetter,
          flex: 1,
          filter: MultiSelectFilter,
          filterParams:{
            width: appConstants.columnWidth.W_300
          }
        }
      ]
    };
  }
}
